"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@pasport/react-ui");
const useAuth_1 = require("../hooks/useAuth");
const react_1 = require("react");
const useLoginUrl_1 = require("../hooks/useLoginUrl");
const LoginScreen = () => {
    const { isLogged } = (0, useAuth_1.useAuth)();
    const { redirectToLogin } = (0, useLoginUrl_1.useLoginUrl)();
    (0, react_1.useEffect)(() => {
        if (!isLogged)
            redirectToLogin();
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_ui_1.CenterView, { children: "P\u0159ihla\u0161ov\u00E1n\u00ED..." }));
};
exports.LoginScreen = LoginScreen;
